import { BetaRegistrationId, UserId, UserRegistrationId } from '@workspace/data-types';
import { ApiCaller } from '../../api-caller.service';
import { BetaRegistrationAdminConnector } from './beta-registrations/beta-registration/beta-registration.connector';
import { BetaRegistrationsAdminConnector } from './beta-registrations/beta-registrations.connector';
import { EmailsAdminConnector } from './emails/emails.connector';
import { FilesAdminConnector } from './files/files.connector';
import { JobConfigsAdminConnector } from './job-configs/job-configs.connector';
import { KeycloakAdminConnector } from './keycloak/keycloak.connector';
import { NotificationsAdminConnector } from './notifications/notifications.connector';
import { PlansAdminConnector } from './plans/plans.connector';
import { SmsAdminConnector } from './sms/sms.connector';
import { StripeSubscriptionEventsAdminConnector } from './stripe-subscription-events/stripe-subscription-events.connector';
import { StripeVerificationSessionsAdminConnector } from './stripe-verification-sessions/stripe-verification-sessions.connector';
import { SubscriptionsAdminConnector } from './subscriptions/subscriptions.connector';
import { TicketsAdminConnector } from './tickets/tickets.connector';
import { TokenVaultsAdminConnector } from './token-vaults/token-vaults.connector';
import { TransactionsAdminConnector } from './transactions/transactions.connector';
import { UserRegistrationAdminConnector } from './user-registrations/user-registration/user-registration.connector';
import { UserRegistrationsAdminConnector } from './user-registrations/user-registrations.connector';
import { UserAdminConnector } from './users/user/user.connector';
import { UsersAdminConnector } from './users/users.connector';

export class AdminConnector {
  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  keycloak = () => new KeycloakAdminConnector(this.apiCaller, this.prefix);
  users = () => new UsersAdminConnector(this.apiCaller, this.prefix);
  user = (userId: UserId) => new UserAdminConnector(this.apiCaller, userId, this.prefix);
  userRegistrations = () => new UserRegistrationsAdminConnector(this.apiCaller, this.prefix);
  userRegistration = (userRegistrationId: UserRegistrationId) =>
    new UserRegistrationAdminConnector(this.apiCaller, userRegistrationId, this.prefix);
  betaRegistrations = () => new BetaRegistrationsAdminConnector(this.apiCaller, this.prefix);
  betaRegistration = (betaRegistrationId: BetaRegistrationId) =>
    new BetaRegistrationAdminConnector(this.apiCaller, betaRegistrationId, this.prefix);
  tokenVaults = () => new TokenVaultsAdminConnector(this.apiCaller, this.prefix);
  files = () => new FilesAdminConnector(this.apiCaller, this.prefix);
  emails = () => new EmailsAdminConnector(this.apiCaller, this.prefix);
  sms = () => new SmsAdminConnector(this.apiCaller, this.prefix);
  notifications = () => new NotificationsAdminConnector(this.apiCaller, this.prefix);
  tickets = () => new TicketsAdminConnector(this.apiCaller, this.prefix);

  subscriptions = () => new SubscriptionsAdminConnector(this.apiCaller, this.prefix);
  transactions = () => new TransactionsAdminConnector(this.apiCaller, this.prefix);
  plans = () => new PlansAdminConnector(this.apiCaller, this.prefix);
  stripeSubscriptionEvents = () => new StripeSubscriptionEventsAdminConnector(this.apiCaller, this.prefix);
  stripeVerificationSessions = () =>
    new StripeVerificationSessionsAdminConnector(this.apiCaller, this.prefix);
  jobConfigs = () => new JobConfigsAdminConnector(this.apiCaller, this.prefix);
}
